{
  "light": {
    "colors": {
      "primary": "#6419E6",
      "primary-focus": "#5016C7",
      "primary-content": "#FFFFFF",
      "secondary": "#E879F9",
      "secondary-focus": "#D946EF",
      "secondary-content": "#FFFFFF",
      "accent": "#F59E0B",
      "accent-focus": "#D97706",
      "accent-content": "#FFFFFF",
      "neutral": "#3D4451",
      "neutral-focus": "#2A2E37",
      "neutral-content": "#FFFFFF",
      "base-100": "#FFFFFF",
      "base-200": "#F2F2F2",
      "base-300": "#E5E6E6",
      "base-content": "#1F2937",
      "info": "#3ABFF8",
      "success": "#36D399",
      "warning": "#FBBD23",
      "error": "#F87272"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "dark": {
    "colors": {
      "primary": "#6419E6",
      "primary-focus": "#5016C7",
      "primary-content": "#FFFFFF",
      "secondary": "#E879F9",
      "secondary-focus": "#D946EF",
      "secondary-content": "#FFFFFF",
      "accent": "#F59E0B",
      "accent-focus": "#D97706",
      "accent-content": "#FFFFFF",
      "neutral": "#2A2E37",
      "neutral-focus": "#16181D",
      "neutral-content": "#A6ADBB",
      "base-100": "#1D232A",
      "base-200": "#191E24",
      "base-300": "#15191E",
      "base-content": "#A6ADBB",
      "info": "#3ABFF8",
      "success": "#36D399",
      "warning": "#FBBD23",
      "error": "#F87272"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "cupcake": {
    "colors": {
      "primary": "#0E7490",
      "primary-focus": "#0F3F4F",
      "primary-content": "#1F2937",
      "secondary": "#D946EF",
      "secondary-focus": "#C026D3",
      "secondary-content": "#1F2937",
      "accent": "#EEAF3A",
      "accent-focus": "#E9A429",
      "accent-content": "#1F2937",
      "neutral": "#291334",
      "neutral-focus": "#1F0E2B",
      "neutral-content": "#D7DDE4",
      "base-100": "#FAF7F5",
      "base-200": "#EFEAE6",
      "base-300": "#E7E2DF",
      "base-content": "#291334",
      "info": "#3ABFF8",
      "success": "#36D399",
      "warning": "#FBBD23",
      "error": "#F87272"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "business": {
    "colors": {
      "primary": "#1C4ED8",
      "primary-focus": "#1E40AF",
      "primary-content": "#FFFFFF",
      "secondary": "#7C3AED",
      "secondary-focus": "#6D28D9",
      "secondary-content": "#FFFFFF",
      "accent": "#F59E0B",
      "accent-focus": "#D97706",
      "accent-content": "#FFFFFF",
      "neutral": "#2D3748",
      "neutral-focus": "#1A202C",
      "neutral-content": "#A0AEC0",
      "base-100": "#FFFFFF",
      "base-200": "#F7FAFC",
      "base-300": "#EDF2F7",
      "base-content": "#1A202C",
      "info": "#3182CE",
      "success": "#38A169",
      "warning": "#D69E2E",
      "error": "#E53E3E"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "grove-dark": {
    "colors": {
      "primary": "#22c55e",
      "primary-focus": "#16a34a",
      "primary-content": "#ffffff",
      "secondary": "#fbbf24",
      "secondary-focus": "#f59e0b",
      "secondary-content": "#000000",
      "accent": "#22c55e",
      "accent-focus": "#16a34a",
      "accent-content": "#ffffff",
      "neutral": "#27272a",
      "neutral-focus": "#18181b",
      "neutral-content": "#fafafa",
      "base-100": "#09090b",
      "base-200": "#18181b",
      "base-300": "#27272a",
      "base-content": "#fafafa",
      "info": "#3b82f6",
      "success": "#22c55e",
      "warning": "#fbbf24",
      "error": "#ef4444"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "grove-light": {
    "colors": {
      "primary": "#22c55e",
      "primary-focus": "#16a34a",
      "primary-content": "#ffffff",
      "secondary": "#fbbf24",
      "secondary-focus": "#f59e0b",
      "secondary-content": "#000000",
      "accent": "#22c55e",
      "accent-focus": "#16a34a",
      "accent-content": "#ffffff",
      "neutral": "#f5f5f4",
      "neutral-focus": "#e7e5e4",
      "neutral-content": "#1c1917",
      "base-100": "#fefefe",
      "base-200": "#f8f8f7",
      "base-300": "#f5f5f4",
      "base-content": "#1a1a1a",
      "info": "#3b82f6",
      "success": "#22c55e",
      "warning": "#f59e0b",
      "error": "#dc2626"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "dawn": {
    "colors": {
      "primary": "#10b981",
      "primary-focus": "#059669",
      "primary-content": "#ffffff",
      "secondary": "#f59e0b",
      "secondary-focus": "#d97706",
      "secondary-content": "#ffffff",
      "accent": "#3b82f6",
      "accent-focus": "#2563eb",
      "accent-content": "#ffffff",
      "neutral": "#1f2937",
      "neutral-focus": "#111827",
      "neutral-content": "#ffffff",
      "base-100": "#ffffff",
      "base-200": "#f3f4f6",
      "base-300": "#e5e7eb",
      "base-content": "#1f2937",
      "info": "#3b82f6",
      "success": "#10b981",
      "warning": "#f59e0b",
      "error": "#ef4444"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "dusk": {
    "colors": {
      "primary": "#818cf8",
      "primary-focus": "#6366f1",
      "primary-content": "#ffffff",
      "secondary": "#f472b6",
      "secondary-focus": "#ec4899",
      "secondary-content": "#ffffff",
      "accent": "#fbbf24",
      "accent-focus": "#f59e0b",
      "accent-content": "#000000",
      "neutral": "#1e293b",
      "neutral-focus": "#0f172a",
      "neutral-content": "#ffffff",
      "base-100": "#0f172a",
      "base-200": "#1e293b",
      "base-300": "#334155",
      "base-content": "#f1f5f9",
      "info": "#60a5fa",
      "success": "#34d399",
      "warning": "#fbbf24",
      "error": "#f87171"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "twilight-light": {
    "colors": {
      "primary": "#8b5cf6",
      "primary-focus": "#7c3aed",
      "primary-content": "#ffffff",
      "secondary": "#a78bfa",
      "secondary-focus": "#9061f9",
      "secondary-content": "#ffffff",
      "accent": "#c084fc",
      "accent-focus": "#b16cfc",
      "accent-content": "#ffffff",
      "neutral": "#e9d5ff",
      "neutral-focus": "#ddd6fe",
      "neutral-content": "#1e1b4b",
      "base-100": "#faf5ff",
      "base-200": "#f3e8ff",
      "base-300": "#ede9fe",
      "base-content": "#1e1b4b",
      "info": "#60a5fa",
      "success": "#34d399",
      "warning": "#fbbf24",
      "error": "#f87171"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "twilight-dark": {
    "colors": {
      "primary": "#8b5cf6",
      "primary-focus": "#7c3aed",
      "primary-content": "#ffffff",
      "secondary": "#a78bfa",
      "secondary-focus": "#9061f9",
      "secondary-content": "#ffffff",
      "accent": "#c084fc",
      "accent-focus": "#b16cfc",
      "accent-content": "#ffffff",
      "neutral": "#2e1065",
      "neutral-focus": "#1e0d3a",
      "neutral-content": "#f3e8ff",
      "base-100": "#0f0519",
      "base-200": "#1e0d3a",
      "base-300": "#2e1065",
      "base-content": "#f3e8ff",
      "info": "#60a5fa",
      "success": "#34d399",
      "warning": "#fbbf24",
      "error": "#f87171"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "squad-light": {
    "colors": {
      "primary": "#14b8a6",
      "primary-focus": "#0d9488",
      "primary-content": "#ffffff",
      "secondary": "#fbbf24",
      "secondary-focus": "#f59e0b",
      "secondary-content": "#000000",
      "accent": "#ef4444",
      "accent-focus": "#dc2626",
      "accent-content": "#ffffff",
      "neutral": "#64748b",
      "neutral-focus": "#475569",
      "neutral-content": "#f8fafc",
      "base-100": "#fcfcfc",
      "base-200": "#f8f9fa",
      "base-300": "#f1f3f5",
      "base-content": "#1e293b",
      "info": "#3b82f6",
      "success": "#22c55e",
      "warning": "#f59e0b",
      "error": "#ef4444"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "squad-dark": {
    "colors": {
      "primary": "#14b8a6",
      "primary-focus": "#0d9488",
      "primary-content": "#ffffff",
      "secondary": "#fbbf24",
      "secondary-focus": "#f59e0b",
      "secondary-content": "#000000",
      "accent": "#ef4444",
      "accent-focus": "#dc2626",
      "accent-content": "#ffffff",
      "neutral": "#334155",
      "neutral-focus": "#1e293b",
      "neutral-content": "#f1f5f9",
      "base-100": "#0f172a",
      "base-200": "#1e293b",
      "base-300": "#334155",
      "base-content": "#f1f5f9",
      "info": "#60a5fa",
      "success": "#34d399",
      "warning": "#fbbf24",
      "error": "#f87171"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "lounge-light": {
    "colors": {
      "primary": "#d97706",
      "primary-focus": "#b45309",
      "primary-content": "#ffffff",
      "secondary": "#451a03",
      "secondary-focus": "#1c0a00",
      "secondary-content": "#fef3c7",
      "accent": "#16a34a",
      "accent-focus": "#15803d",
      "accent-content": "#ffffff",
      "neutral": "#57534e",
      "neutral-focus": "#44403c",
      "neutral-content": "#fafaf9",
      "base-100": "#fffbeb",
      "base-200": "#fef3c7",
      "base-300": "#fde68a",
      "base-content": "#1c1917",
      "info": "#3b82f6",
      "success": "#22c55e",
      "warning": "#fbbf24",
      "error": "#dc2626"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "lounge-dark": {
    "colors": {
      "primary": "#d97706",
      "primary-focus": "#b45309",
      "primary-content": "#ffffff",
      "secondary": "#78350f",
      "secondary-focus": "#451a03",
      "secondary-content": "#fef3c7",
      "accent": "#16a34a",
      "accent-focus": "#15803d",
      "accent-content": "#ffffff",
      "neutral": "#292524",
      "neutral-focus": "#1c1917",
      "neutral-content": "#e7e5e4",
      "base-100": "#0c0a09",
      "base-200": "#1c1917",
      "base-300": "#292524",
      "base-content": "#e7e5e4",
      "info": "#60a5fa",
      "success": "#34d399",
      "warning": "#fbbf24",
      "error": "#f87171"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "meadow-light": {
    "colors": {
      "primary": "#16a34a",
      "primary-focus": "#15803d",
      "primary-content": "#ffffff",
      "secondary": "#0ea5e9",
      "secondary-focus": "#0284c7",
      "secondary-content": "#ffffff",
      "accent": "#fef3c7",
      "accent-focus": "#fde68a",
      "accent-content": "#713f12",
      "neutral": "#4ade80",
      "neutral-focus": "#22c55e",
      "neutral-content": "#052e16",
      "base-100": "#dcfce7",
      "base-200": "#bbf7d0",
      "base-300": "#86efac",
      "base-content": "#14532d",
      "info": "#3b82f6",
      "success": "#22c55e",
      "warning": "#facc15",
      "error": "#fb923c"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "meadow-dark": {
    "colors": {
      "primary": "#16a34a",
      "primary-focus": "#15803d",
      "primary-content": "#ffffff",
      "secondary": "#0284c7",
      "secondary-focus": "#0369a1",
      "secondary-content": "#ffffff",
      "accent": "#fde68a",
      "accent-focus": "#fcd34d",
      "accent-content": "#451a03",
      "neutral": "#166534",
      "neutral-focus": "#14532d",
      "neutral-content": "#bbf7d0",
      "base-100": "#14532d",
      "base-200": "#166534",
      "base-300": "#15803d",
      "base-content": "#bbf7d0",
      "info": "#60a5fa",
      "success": "#34d399",
      "warning": "#fde047",
      "error": "#fdba74"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "focus-light": {
    "colors": {
      "primary": "#ea580c",
      "primary-focus": "#dc2626",
      "primary-content": "#ffffff",
      "secondary": "#525252",
      "secondary-focus": "#404040",
      "secondary-content": "#fafafa",
      "accent": "#9333ea",
      "accent-focus": "#7c3aed",
      "accent-content": "#ffffff",
      "neutral": "#737373",
      "neutral-focus": "#525252",
      "neutral-content": "#fafafa",
      "base-100": "#ffffff",
      "base-200": "#fafafa",
      "base-300": "#f5f5f5",
      "base-content": "#171717",
      "info": "#06b6d4",
      "success": "#22c55e",
      "warning": "#facc15",
      "error": "#f87171"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  },
  "focus-dark": {
    "colors": {
      "primary": "#ea580c",
      "primary-focus": "#dc2626",
      "primary-content": "#ffffff",
      "secondary": "#404040",
      "secondary-focus": "#262626",
      "secondary-content": "#f5f5f5",
      "accent": "#9333ea",
      "accent-focus": "#7c3aed",
      "accent-content": "#ffffff",
      "neutral": "#404040",
      "neutral-focus": "#262626",
      "neutral-content": "#e5e5e5",
      "base-100": "#0a0a0a",
      "base-200": "#171717",
      "base-300": "#262626",
      "base-content": "#f5f5f5",
      "info": "#0891b2",
      "success": "#34d399",
      "warning": "#fde047",
      "error": "#fca5a5"
    },
    "spacing": {
      "0": "0px",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem"
    },
    "typography": {
      "fontSize": {
        "xs": [
          "0.6875rem",
          {
            "lineHeight": "0.9375rem"
          }
        ],
        "sm": [
          "0.8125rem",
          {
            "lineHeight": "1.125rem"
          }
        ],
        "base": [
          "0.9375rem",
          {
            "lineHeight": "1.375rem"
          }
        ],
        "lg": [
          "1rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "xl": [
          "1.0625rem",
          {
            "lineHeight": "1.5rem"
          }
        ],
        "2xl": [
          "1.1875rem",
          {
            "lineHeight": "1.625rem"
          }
        ],
        "3xl": [
          "1.375rem",
          {
            "lineHeight": "1.75rem"
          }
        ],
        "4xl": [
          "1.625rem",
          {
            "lineHeight": "1.875rem"
          }
        ],
        "5xl": [
          "2rem",
          {
            "lineHeight": "1"
          }
        ]
      },
      "fontWeight": {
        "normal": "400",
        "medium": "500",
        "semibold": "600",
        "bold": "700"
      }
    },
    "animation": {
      "duration": {
        "fast": "150ms",
        "base": "300ms",
        "slow": "500ms",
        "slower": "700ms"
      },
      "easing": {
        "default": "cubic-bezier(0.4, 0, 0.2, 1)",
        "linear": "linear",
        "in": "cubic-bezier(0.4, 0, 1, 1)",
        "out": "cubic-bezier(0, 0, 0.2, 1)",
        "inOut": "cubic-bezier(0.4, 0, 0.2, 1)"
      }
    },
    "shadows": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "base": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    "borderRadius": {
      "none": "0",
      "sm": "0.125rem",
      "base": "0.25rem",
      "md": "0.375rem",
      "lg": "0.5rem",
      "xl": "0.75rem",
      "2xl": "1rem",
      "full": "9999px"
    }
  }
}